// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";
import { principalRefSchema } from "@pureid/auth-core";

export const approverSchema = z.object({
  "admin_user_id": z.string().uuid(),
  "email": z.string(),
  "name": z.string(),
  "role": z.string(),
  "source_org_id": z.string().uuid().optional(),
  "source_org_name": z.string().optional(),
  "source_grant_id": z.string().uuid().optional(),
  "scope": z.enum(["tenant", "tenant_grant", "managed_provider", "org"]),
  "in_routing_pool": z.boolean()
});

export const listApproversResponseSchema = z.object({
  "data": z.array(approverSchema),
  "pool_mode": z.enum(["all", "subset"]),
  "pool_member_ids": z.array(z.string().uuid())
});

export const decisionAvailabilitySchema = z.object({
  "allowed": z.boolean(),
  "reason": z.string().optional()
});

export const queueEntrySchema = z.object({
  "Kind": z.enum(["recovery", "access"]),
  "ID": z.string().uuid(),
  "TenantID": z.string().uuid(),
  "SubjectUserID": z.string().uuid().nullable(),
  "group_id": z.string().uuid().optional(),
  "group_name": z.string().optional(),
  "membership_mode": z.enum(["dynamic"]).optional(),
  "current_member_count": z.number().int().min(0).optional(),
  "SubjectEmail": z.string(),
  "SubjectDisplayName": z.string(),
  "SubjectStatus": z.string(),
  "ApplicationID": z.string().uuid().nullable().optional(),
  "ApplicationName": z.string(),
  "AccessType": z.string(),
  "DurationMinutes": z.number().int(),
  "approved_duration_minutes": z.number().int().min(15).max(43200).optional(),
  "access_scope": z.array(z.unknown().refine((value) => [z.object({
    "resource_id": z.string().uuid(),
    "protocol": z.enum(["https", "ssh", "sftp", "rdp"]),
    "target": z.string(),
    "account": z.string().optional(),
    "ssh_auth_method": z.enum(["certificate", "password", "keyboard_interactive"]).optional(),
    "require_connection_approval": z.boolean().optional()
  }), z.object({
    "kind": z.enum(["destination_range"]),
    "membership": z.enum(["dynamic_registered"]),
    "group_id": z.string().uuid(),
    "destination_cidr": z.string(),
    "protocol": z.enum(["ssh", "sftp", "rdp"]),
    "port": z.number().int().min(1).max(65535),
    "account": z.string()
  })].filter((variant) => variant.safeParse(value).success).length === 1, "Expected exactly one supported variant").pipe(z.union([z.object({
    "resource_id": z.string().uuid(),
    "protocol": z.enum(["https", "ssh", "sftp", "rdp"]),
    "target": z.string(),
    "account": z.string().optional(),
    "ssh_auth_method": z.enum(["certificate", "password", "keyboard_interactive"]).optional(),
    "require_connection_approval": z.boolean().optional()
  }), z.object({
    "kind": z.enum(["destination_range"]),
    "membership": z.enum(["dynamic_registered"]),
    "group_id": z.string().uuid(),
    "destination_cidr": z.string(),
    "protocol": z.enum(["ssh", "sftp", "rdp"]),
    "port": z.number().int().min(1).max(65535),
    "account": z.string()
  })]))).nullable().optional(),
  "ExpiresAt": z.string().nullable().optional(),
  "GrantExpiresAt": z.string().nullable().optional(),
  "GrantExists": z.boolean().default(false),
  "Reason": z.string(),
  "Status": z.string(),
  "NRequiredApprovals": z.number().int(),
  "ActiveStageIndex": z.number().int().default(0),
  "StageCount": z.number().int().default(1),
  "TotalRequiredApprovals": z.number().int().default(0),
  "decision_comment": z.string().default(""),
  "decided_by": z.string().default(""),
  "RequestedAt": z.string(),
  "RequestedBy": z.string().uuid().nullable().optional(),
  "EscalatesAt": z.string().nullable().optional(),
  "ApproveCount": z.number().int(),
  "DenyCount": z.number().int(),
  "NeedsInfoCount": z.number().int(),
  "CommentCount": z.number().int(),
  "Priority": z.enum(["critical", "high", "normal"]),
  "SLABucket": z.enum(["overdue", "due_today", "this_week", "fresh"]),
  "is_first_request_ever": z.boolean().nullable().optional(),
  "is_first_request_for_app": z.boolean().nullable().optional(),
  "peer_count_with_app": z.number().int().nullable().optional(),
  "submitted_outside_hours": z.boolean().nullable().optional(),
  "recent_denial_count": z.number().int().nullable().optional(),
  "subject_title": z.string().default(""),
  "subject_department": z.string().default(""),
  "subject_manager": z.string().default(""),
  "decision_availability": decisionAvailabilitySchema.optional()
});

export const queueResponseSchema = z.object({
  "data": z.array(queueEntrySchema),
  "pagination": z.object({
    "total": z.number().int(),
    "offset": z.number().int(),
    "limit": z.number().int()
  })
});

export const threadCommentSchema = z.object({
  "ID": z.string().uuid(),
  "TenantID": z.string().uuid(),
  "RequestKind": z.enum(["access", "recovery"]),
  "RequestID": z.string().uuid(),
  "AuthorKind": z.enum(["user", "admin", "system"]),
  "AuthorUserID": z.string().uuid().nullable(),
  "AuthorAdminID": z.string().uuid().nullable(),
  "Body": z.string(),
  "EvidenceIDs": z.array(z.string().uuid()),
  "Source": z.enum(["chat", "needs_info", "lifecycle"]),
  "CreatedAt": z.string().datetime({ offset: true }),
  "AuthorEmail": z.string(),
  "AuthorDisplayName": z.string()
});

export const decisionRecordSchema = z.object({
  "ID": z.string().uuid(),
  "TenantID": z.string().uuid(),
  "RequestKind": z.enum(["access", "recovery"]),
  "RequestID": z.string().uuid(),
  "ApproverPrincipalKind": z.enum(["admin", "user"]),
  "ApproverID": z.string().uuid(),
  "ApproverEmail": z.string(),
  "ApproverDisplayName": z.string(),
  "StageIndex": z.number().int().min(0),
  "Decision": z.enum(["approved", "denied", "needs_info", "reversed"]),
  "ReversesID": z.string().uuid().nullable(),
  "Comment": z.string(),
  "DecidedAt": z.string().datetime({ offset: true }),
  "IsPlatformOverride": z.boolean(),
  "ApproverScope": z.enum(["tenant", "tenant_grant", "managed_provider", "org", "peer_nominated", "platform_override", "policy_resolved", "delegated"]),
  "ApproverSourceID": z.string().uuid().nullable()
});

export const attestationSchema = z.object({
  "ID": z.string().uuid(),
  "TenantID": z.string().uuid(),
  "RequestKind": z.enum(["access", "recovery"]),
  "RequestID": z.string().uuid(),
  "Method": z.enum(["video_call", "in_person", "phone_call", "government_id", "manager_attestation", "security_question", "other"]),
  "EvidenceID": z.string().uuid().nullable(),
  "Notes": z.string(),
  "AttestedBy": z.string().uuid(),
  "AttestedAt": z.string().datetime({ offset: true }),
  "AttestedByEmail": z.string()
});

export const processingHealthSchema = z.object({
  "tenant_id": z.string().uuid(),
  "queue_depth_pending": z.number().int().min(0),
  "queue_depth_awaiting_info": z.number().int().min(0),
  "oldest_pending_at": z.string().datetime({ offset: true }).optional(),
  "active_grants": z.number().int().min(0),
  "expiring_soon_count": z.number().int().min(0),
  "unresolvable_count": z.number().int().min(0),
  "last_expiry_sweep_at": z.string().datetime({ offset: true }).optional(),
  "last_reminder_sweep_at": z.string().datetime({ offset: true }).optional(),
  "last_stale_pending_sweep_at": z.string().datetime({ offset: true }).optional(),
  "last_unavailable_sweep_at": z.string().datetime({ offset: true }).optional(),
  "last_deactivation_sweep_at": z.string().datetime({ offset: true }).optional(),
  "last_escalation_sweep_at": z.string().datetime({ offset: true }).optional(),
  "last_budget_reset_anomaly_sweep_at": z.string().datetime({ offset: true }).optional(),
  "health_status": z.enum(["green", "amber", "red"])
});

export const approvalPolicySchema = z.object({
  "policy_id": z.string().uuid(),
  "version": z.number().int().min(1),
  "request_type": z.enum(["access", "recovery"]),
  "scope_kind": z.enum(["tenant", "application", "organization", "sensitivity"]),
  "scope_app_id": z.string().uuid().optional(),
  "scope_org_id": z.string().uuid().optional(),
  "scope_sensitivity": z.enum(["normal", "sensitive"]).optional(),
  "sod_posture": z.enum(["safe_default_by_sensitivity", "manager_allowed", "manager_forbidden", "manager_plus_peer"]),
  "plan": z.object({
    "version": z.enum(["v1"]),
    "stages": z.array(z.object({
      "stage_index": z.number().int().min(0).max(4),
      "n_required": z.number().int().min(1).max(5),
      "rules": z.array(z.object({
        "kind": z.enum(["admin_role", "manager", "resource_owner", "designated"]),
        "designated_user_ids": z.array(z.string().uuid()).optional(),
        "designated_admin_ids": z.array(z.string().uuid()).optional()
      })).min(1)
    })).min(1).max(5)
  }),
  "is_current": z.boolean(),
  "updated_at": z.string().datetime({ offset: true }),
  "updated_by": z.string().uuid().optional(),
  "created_by": z.string().uuid().optional(),
  "created_by_ref": principalRefSchema.optional()
});

export const approvalPolicyListSchema = z.object({
  "data": z.array(approvalPolicySchema),
  "count": z.number().int().min(0)
});

export const routingPolicyResponseSchema = z.object({
  "tenant_id": z.string().uuid(),
  "recovery_n_required": z.number().int().min(1).max(5),
  "recovery_approver_pool": z.array(z.string().uuid()),
  "recovery_escalation_minutes": z.number().int().min(60).max(10080),
  "recovery_expire_minutes": z.number().int().min(60).max(43200),
  "access_n_required_normal": z.number().int().min(1).max(5),
  "access_n_required_sensitive": z.number().int().min(1).max(5),
  "access_n_required_standing": z.number().int().min(2).max(5),
  "access_approver_pool": z.array(z.string().uuid()),
  "access_escalation_minutes": z.number().int().min(15).max(4320),
  "access_expire_minutes": z.number().int().min(60).max(10080),
  "allow_immediate_resubmit": z.boolean(),
  "resubmit_cooling_off_minutes": z.number().int().min(0)
});
